<template>
  <div v-if="!allocatedItemsExistenceMap[partTypeKey]">
    <pdl-section-header size="md" :is-dividing="true" class="mt-2 mb-4" qaid="orderDetails.header">
      <template #content>
        <pdl-heading :key="headerKey">{{ headerText }}</pdl-heading>
      </template>
    </pdl-section-header>

    <table class="dataTable" :aria-label="hdeaderText">
      <thead>
        <th class="w-48 lg:w-64 lg:pr-4 py-0"></th>
        <th class="py-0"></th>
      </thead>
      <tr v-if="checkoutStep === 'confirmation'">
        <td class="pr-4">
          <span v-if="partTypeKey === 'bikes' && bikesOrderUpdate.length !== 0" key="bikes-order-update">
            {{ $t('text.account.orderHistory.orderNumber') }}
          </span>
          <span v-else-if="partTypeKey === 'parts' && partsOrderUpdate.length !== 0" key="parts-order-update">
            {{ $t('text.account.orderHistory.orderNumber') }}
          </span>
          <span
            v-else-if="partTypeKey === 'customWaterBottles' && customWaterBottlesOrderUpdate.length !== 0"
            key="custom-water-bottles-order-update"
          >
            {{ $t('text.account.orderHistory.orderNumber') }}
          </span>
          <span v-else-if="timeoutError || emptyReturnError" key="empty-return-error"> </span>
          <span v-else key="order-number-parts">
            {{ $t('text.account.orderHistory.orderNumber') }}
          </span>
        </td>
        <td v-if="partTypeKey === 'bikes' && bikesOrderUpdate.length !== 0">
          {{ bikesOrderUpdate }}
        </td>
        <td v-else-if="partTypeKey === 'parts' && partsOrderUpdate.length !== 0">
          {{ partsOrderUpdate }}
        </td>
        <td v-else-if="partTypeKey === 'customWaterBottles' && customWaterBottlesOrderUpdate.length !== 0">
          {{ customWaterBottlesOrderUpdate }}
        </td>
        <td v-else-if="partTypeKey === 'projectOneBikes' && projectOneBikesOrderUpdate.length !== 0">
          {{ projectOneBikesOrderUpdate }}
        </td>
        <td v-else-if="partTypeKey === 'projectOneBikes' && projectOneWarrantyFramesetOrderUpdate.length !== 0">
          {{ projectOneWarrantyFramesetOrderUpdate }}
        </td>
        <td v-else-if="!timeoutError && !emptyReturnError">
          <pdl-loading class="min-h-0" inline message="Please wait..." :is-loading="loading" />
        </td>
        <td v-else></td>
      </tr>
      <tr>
        <td class="pr-4">{{ $t('text.customerPo') }}</td>
        <td>{{ orderDetails.customerPO }}</td>
      </tr>

      <tr v-if="isDropShip">
        <td class="pr-4">{{ $t('distributor.B2B.container.port') }}</td>
        <td>{{ orderDetails.portofDelivery }}</td>
      </tr>

      <tr v-if="!isDropShip">
        <td>{{ $t('text.holdOptions') }}</td>
        <td>
          <div class="max-w-sm">
            <p class="mt-0">{{ orderDetails.holdValue }}</p>
            <p>
              {{ orderDetails.holdNote }}
            </p>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import {PdlLoading} from '@pedal/pdl-loading';
import {PdlSectionHeader, PdlHeading} from '@pedal/pdl-section-header';

export default {
  name: 'OrderDetails',

  components: {
    PdlLoading,
    PdlSectionHeader,
    PdlHeading,
  },

  props: {
    checkoutStep: {
      type: String,
      default: '',
    },
    partTypeKey: {
      type: String,
      default: '',
    },
    bikesOrderDetails: {
      type: Object,
      default: () => null,
    },
    partsOrderDetails: {
      type: Object,
      default: () => null,
    },
    customWaterBottlesOrderDetails: {
      type: Object,
      default: () => null,
    },
    projectOneBikesOrderDetails: {
      type: Object,
      default: () => null,
    },
    bikesOrderCode: {
      type: String,
      default: '',
    },
    bikesOrderUpdate: {
      type: String,
      default: '',
    },
    partsOrderCode: {
      type: String,
      default: '',
    },
    partsOrderUpdate: {
      type: String,
      default: '',
    },
    customWaterBottlesOrderCode: {
      type: String,
      default: '',
    },
    customWaterBottlesOrderUpdate: {
      type: String,
      default: '',
    },
    projectOneBikesOrderCode: {
      type: String,
      default: '',
    },
    projectOneBikesOrderUpdate: {
      type: String,
      default: '',
    },
    projectOneWarrantyFramesetOrderCode: {
      type: String,
      default: '',
    },
    projectOneWarrantyFramesetOrderUpdate: {
      type: String,
      default: '',
    },
    timeoutError: {
      type: Boolean,
      default: false,
    },
    emptyReturnError: {
      type: Boolean,
      default: false,
    },
    isDropShip: {
      type: Boolean,
      default: false,
    },
    allocatedItemsExistenceMap: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      loading: true,
    };
  },
  computed: {
    orderDetails() {
      let selectedTabOrderDetails;
      switch (this.partTypeKey) {
        case 'bikes':
          selectedTabOrderDetails = this.bikesOrderDetails;
          break;
        case 'parts':
          selectedTabOrderDetails = this.partsOrderDetails;
          break;
        case 'customWaterBottles':
          selectedTabOrderDetails = this.customWaterBottlesOrderDetails;
          break;
        case 'projectOneBikes':
          selectedTabOrderDetails = this.projectOneBikesOrderDetails;
          break;
        default:
          break;
      }
      return selectedTabOrderDetails;
    },
    headerKey() {
      let headerKey;
      switch (this.partTypeKey) {
        case 'bikes':
          headerKey = 'order-details-bikes-heading';
          break;
        case 'parts':
          headerKey = 'order-details-parts-heading';
          break;
        case 'customWaterBottles':
          headerKey = 'order-details-custom-water-bottles-heading';
          break;
        case 'projectOneBikes':
          headerKey = 'order-details-project-one-heading';
          break;
        default:
          break;
      }
      return headerKey;
    },
    headerText() {
      let headerText;
      switch (this.partTypeKey) {
        case 'bikes':
          headerText = this.$t('text.bikeOrderDetails');
          break;
        case 'parts':
          headerText = this.$t('text.accessoryOrderDetails');
          break;
        case 'customWaterBottles':
          headerText = this.$t('checkout.custom.orderDetails');
          break;
        case 'projectOneBikes':
          headerText = this.$t('checkout.projectOne.orderDetails');
          break;
        default:
          break;
      }
      return headerText;
    },
  },
};
</script>
